import { render, staticRenderFns } from "./Packing.vue?vue&type=template&id=473be01d&scoped=true"
import script from "./Packing.vue?vue&type=script&lang=ts"
export * from "./Packing.vue?vue&type=script&lang=ts"
import style0 from "./Packing.vue?vue&type=style&index=0&id=473be01d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473be01d",
  null
  
)

export default component.exports